import React from 'react';
import PropTypes from 'prop-types';
import { FiUpload, FiX } from 'react-icons/fi';

function FormImageUpload({
  id,
  label,
  imagePreview,
  onChange,
  onRemove,
  className,
}) {
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center">
        {imagePreview ? (
          <div className="relative">
            <img
              src={imagePreview}
              alt="Preview"
              className="h-40 mx-auto rounded-md object-contain"
            />
            <button
              type="button"
              onClick={onRemove}
              className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1"
              aria-label="Remove image"
            >
              <FiX size={16} />
            </button>
          </div>
        ) : (
          <div className="space-y-2">
            <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
            <div className="flex text-sm text-gray-600 items-center justify-center">
              <label
                htmlFor={id}
                className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none"
              >
                <span>Upload an image</span>
                <input
                  id={id}
                  type="file"
                  className="sr-only"
                  onChange={onChange}
                  accept="image/*"
                />
              </label>
              <p className="pl-1">or drag and drop</p>
            </div>
            <p className="text-xs text-gray-500">PNG, JPG up to 2MB</p>
          </div>
        )}
      </div>
    </div>
  );
}

FormImageUpload.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  imagePreview: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  className: PropTypes.string,
};

FormImageUpload.defaultProps = {
  imagePreview: null,
  className: '',
};

export default FormImageUpload;
